import axios from "axios";

import { getQueryString } from "../resources/utils";

const {
    REACT_APP_API_URL,
} = process.env;
// Api Call for search

export function doSearchForProperty(queryParams) {
    const queryString = queryParams ? getQueryString(queryParams) : "";
    const apiUrl = `${REACT_APP_API_URL}property-search?${queryString}`;
    return axios.get(apiUrl);
  }
  
  export function doLocationSearch(queryParams) {
    const queryString = queryParams ? getQueryString(queryParams) : "";
    const apiUrl = `${REACT_APP_API_URL}locations?${queryString}`;
    return axios.get(apiUrl);
  }